import React from "react";
import "./SideMenu2.scss";
import { Link, useLocation } from "react-router-dom";

const SideMenu2 = () => {
  const location = useLocation();
  return (
    <div className="SideListCont2">
      <ul className="list">
        <li>
          <Link
            className={location.pathname.includes("deals") ? "activeLink" : ""}
            to="/deals"
          >
            Акции
          </Link>
        </li>
        <li>
          <Link
            className={location.pathname.includes("bonus") ? "activeLink" : ""}
            to="/bonus"
          >
            Бонусная программа
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("privilege") ? "activeLink" : ""
            }
            to="/privilege"
          >
            Льготное обеспечение
          </Link>
        </li>
        <li>
          <Link
            className={
              location.pathname.includes("production") ? "activeLink" : ""
            }
            to="/production"
          >
            Изготовление лекарств
          </Link>
        </li>
        <li>
          <Link
            className={location.pathname.includes("optica") ? "activeLink" : ""}
            to="/optica"
          >
            Оптика
          </Link>
        </li>
        <li>
          <Link
            className={location.pathname.includes("legal") ? "activeLink" : ""}
            to="/legal"
          >
            Оптовым покупателям
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideMenu2;
